export enum EmployeeSort {
    NameSortOption = 'Name',
    TitleSortOption = 'Title',
    CurrentPayAscending = 'Current Pay: Low to High',
    CurrentPayDescending = 'Current Pay: High to Low',
    HireDateSortOption = 'Hire Date',
    LastPayChangeDateSortOption = 'Last Pay Change Date',
    PerformanceRatingSortOption = 'Performance Rating'
}